import { Segmentacao } from './segmentacao-ocultar-menu-avaliacoes.types';

const segmentacoes: Array<Segmentacao> = [
  {
    marcas: ['estacio', 'wyden'],
    periodo: '2025.4',
    modalidades: ['EAD', 'FLEX'],
  },
  {
    marcas: ['estacio', 'wyden'],
    periodo: '2026.2',
    modalidades: ['PRESENCIAL', 'AO_VIVO'],
    inicioVigencia: '2026-08-01',
    fimVigencia: '2026-09-07',
  },
  {
    marcas: ['estacio', 'wyden'],
    periodo: '2026.3',
    modalidades: ['EAD', 'SEMI', 'FLEX'],
    inicioVigencia: '2026-08-01',
    fimVigencia: '2026-09-07',
  },
  {
    marcas: ['estacio', 'wyden'],
    periodo: '2026.4',
    modalidades: ['EAD', 'FLEX'],
    inicioVigencia: '2026-10-05',
    fimVigencia: '2026-11-20',
  },
];

export const segmentacaoOcultarMenuAvaliacoesConfig: Array<Segmentacao> = segmentacoes;
